import { useState } from "react";
import { Blurhash } from "react-blurhash";

import { urlFor } from "../../client";
import Button from "../Utils/Button";

const coachHash =
  "XlKLaws+~TWEadR.WZ^#kDI]jYRPoft7${WCNLafRkoea}NLoJV@ofxuWBn$";

export default function Coach({ item }) {
  const { title, slug, mainImage } = item;
  const [loaded, setLoaded] = useState(false);

  // console.log(loaded);
  // Function to handle image load event
  const handleImageLoad = () => {
    setLoaded(true);
  };
  const info = title.split("-");
  // console.log(info);

  return (
    <div className="Coach__Container">
      {!loaded && (
        <div style={{ width: "100%", height: "400px", objectFit: "cover" }}>
          <Blurhash
            hash={`${coachHash}`}
            width="100%"
            height="100%"
            resolutionX={32}
            resolutionY={32}
            punch={1}
          />
        </div>
      )}
      {mainImage && mainImage.asset && (
        <img
          src={urlFor(mainImage).url()}
          style={{ width: "100%", height: "400px", objectFit: "cover" }}
          alt={title}
          onLoad={handleImageLoad}
        />
      )}

      <div className=" Programs__Text--div" style={{ top: "70%" }}>
        <div className="Coach__Staff--info">
          {info[0] && <p className="Coach__Name">{info[0]}</p>}
          {info[1] && <p className="Coach__Role">{info[1]}</p>}
        </div>
        <div style={{ display: "flex" }}>
          <Button
            text={"read more"}
            div={{
              padding: "5px 10px",
              textTransform: "capitalize",
              backgroundColor: "#fff",
              fontWeight:"700",
              width:"100%"
            }}
            link={{
              fontSize: "1.6rem",
              letterSpacing: "2px",
              color: "#007ebb",
            }}
            url={`/coaches/${slug.current}`}
          />
        </div>
      </div>
    </div>
  );
}
